module.exports = __webpack_public_path__ + "static/img/addwx-light.f267a96b.png";